import { MenuDivider } from '@chakra-ui/react';

import { BoxArchived, DoorClosed } from '@enterprise/ui';

import type { MailingsMenuProps } from './types/mailings-menu.props';

import MailingTypeMenu from './mailing-type-menu';
import NavMenuItem from './nav-menu-item';
import RadioMenuItem from './radio-menu-item';

const MailingsMenu = ({ isActive }: MailingsMenuProps) => {
  return (
    <MailingTypeMenu
      externalMenuItemsSlot={({ selectedMenu }) => {
        return (
          <RadioMenuItem
            icon={
              <DoorClosed
                size="lg"
                widthAuto
              />
            }
            isSelected={selectedMenu === 'external-closed'}
            replace
            state={{ selectedMenu: 'external-closed' }}
            to={{
              pathname: '/datastream/packagemanager/external/closed',
            }}>
            Closed
          </RadioMenuItem>
        );
      }}
      hspMenuItemsSlot={({ selectedMenu }) => {
        return (
          <RadioMenuItem
            icon={
              <DoorClosed
                size="lg"
                widthAuto
              />
            }
            isSelected={selectedMenu === 'internal-closed'}
            replace
            state={{ selectedMenu: 'internal-closed' }}
            to={{
              pathname: '/datastream/packagemanager/closed',
            }}>
            Closed
          </RadioMenuItem>
        );
      }}
      isActive={isActive}
      label="Package Manager"
      pathSegment="packagemanager">
      <MenuDivider />
      <NavMenuItem
        icon={
          <BoxArchived
            size="lg"
            widthAuto
          />
        }
        isDisabled>
        Archived
      </NavMenuItem>
    </MailingTypeMenu>
  );
};

export default MailingsMenu;
